/* Recargo de equivalencia (PRUEBA · solo tema borrador) — Emarola
   Añade al carrito una línea de recargo = 5,2% de la base de artículos,
   SOLO para clientes con la etiqueta 'recargo-equivalencia'.
   Mecanismo (Shopify Grow): variante oculta de 0,01 € y cantidad = céntimos del recargo.
   La línea lleva la propiedad _recargo_equivalencia para que el ERP la reconozca. */
(function () {
  var cfg = window.__RECARGO || {};
  if (!cfg.re || !cfg.feeVariant) return;               // solo clientes de recargo
  var FEE = Number(cfg.feeVariant);
  var RATE = Number(cfg.rate) || 0.052;
  var busy = false, lastTarget = -1;

  function cart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  // Misma regla de portes que la tienda (España): tarifa fija salvo envío gratis a partir de un umbral.
  var SHIP_FLAT = (cfg.shipFlat != null) ? Number(cfg.shipFlat) : 0;          // céntimos (p.ej. 600 = 6 €)
  var SHIP_FREE_FROM = (cfg.shipFreeFrom != null) ? Number(cfg.shipFreeFrom) : null; // céntimos (p.ej. 100000 = 1000 €); null = nunca gratis
  function computeTarget(c) {
    var goods = 0;
    (c.items || []).forEach(function (it) {
      if (it.variant_id === FEE) return;                // la propia línea de recargo no cuenta
      goods += it.final_line_price;                     // céntimos, ya con descuentos de línea
    });
    var ship = (SHIP_FREE_FROM != null && goods >= SHIP_FREE_FROM) ? 0 : SHIP_FLAT;
    return Math.round((goods + ship) * RATE);           // céntimos de recargo (sobre mercancía + porte)
  }

  function apply() {
    if (busy) return;
    busy = true;
    cart().then(function (c) {
      var fee = (c.items || []).filter(function (it) { return it.variant_id === FEE; })[0];
      var target = computeTarget(c);
      var current = fee ? fee.quantity : 0;
      if (target === current) { busy = false; lastTarget = target; return; }
      lastTarget = target;
      var done = function () { busy = false; };
      if (target <= 0) {
        if (fee) return fetch('/cart/change.js', opts({ id: String(FEE), quantity: 0 })).then(done).catch(done);
        busy = false; return;
      }
      if (fee) return fetch('/cart/change.js', opts({ id: String(FEE), quantity: target })).then(done).catch(done);
      return fetch('/cart/add.js', opts({ items: [{ id: FEE, quantity: target, properties: { _recargo_equivalencia: '5,2%' } }] })).then(done).catch(done);
    }).catch(function () { busy = false; });
  }

  function opts(body) { return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }; }

  // Dispara al cargar y tras cualquier cambio del carrito (add/change/update/clear).
  document.addEventListener('DOMContentLoaded', apply);
  var _fetch = window.fetch;
  window.fetch = function () {
    var url = (arguments[0] && arguments[0].url) || arguments[0] || '';
    var p = _fetch.apply(this, arguments);
    try {
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url) && url.indexOf('/cart.js') === -1) {
        p.then(function () { setTimeout(apply, 350); });
      }
    } catch (e) {}
    return p;
  };

  // Oculta la cantidad enorme de la línea de recargo en carrito/drawer (cosmético).
  var css = document.createElement('style');
  css.textContent = '[data-recargo-hide-qty] .quantity, [data-recargo-hide-qty] cart-remove-button{visibility:hidden}';
  document.head.appendChild(css);
})();
